import { PROSTRATION_MS } from '../../shared/world';

/** Let the bell settle before it is invited again (AGENTS.md §3.7). */
export const BELL_REST_MS = 5000;

/**
 * Fraction of a prostration at which the forehead touches the ground.
 * GardenScene draws the full prostration while phase > 0.3, so the soft bell lands just after.
 */
export const FOREHEAD_FRACTION = 0.32;

/** Moments when the bell sounds by itself. Walking, palms, greeting and single beads stay silent. */
export type BellMoment = 'arrive' | 'bow' | 'ritual' | 'beadsRound' | 'restStart' | 'restEnd';

/** Each prostration gets a lighter strike that is not held back by the rest period, like the bell at each bow in a repentance ceremony. */
export function bellStrength(moment: BellMoment): 'full' | 'soft' {
  return moment === 'bow' ? 'soft' : 'full';
}

/** Milliseconds from `serverNow` until the forehead touches the ground in a prostration ending at `actionUntil`. */
export function foreheadDelay(actionUntil: number, serverNow: number): number {
  return Math.max(0, actionUntil - PROSTRATION_MS * (1 - FOREHEAD_FRACTION) - serverNow);
}

/** Full strikes share one rest period. An automatic strike during the rest is skipped, never queued. */
export function createBellGate(clock: () => number = Date.now) {
  let until = 0;
  return {
    resting: () => clock() < until,
    restingUntil: () => until,
    take(): boolean {
      if (clock() < until) return false;
      until = clock() + BELL_REST_MS;
      return true;
    },
    reset() { until = 0; },
  };
}
